// extracted by mini-css-extract-plugin
export default {"root":"analyticsRow_root__sOPe8","column":"analyticsRow_column__pu0X6","statistics":"analyticsRow_statistics__AD+TL"};